import { FormElement } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { Url } from "../../../../router/enums";
import { ocNumberMask } from "../../../../utilities/masks";

import { ComponentId } from "./enums";
import { selectFormData } from "./perpetrator.selectors";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  redirect: Url.OC_PROPERTY_INCIDENT,
  selector: selectFormData,
  content: [
    {
      title: "Dane sprawcy",
      sections: [
        {
          id: "reporter-vehicle-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.REGISTRATION_NUMBER,
              label: "Numer rejestracyjny pojazdu sprawcy",
              required: true,
            },
            {
              type: FormElement.INPUT,
              prefix: "PL-OC",
              mask: ocNumberMask,
              id: ComponentId.OC_NUMBER,
              label: "Numer polisy sprawcy",
              required: true,
            },
          ],
        },
      ],
    },
  ],
};
